import styled from 'styled-components';

const LogoStyle = styled.div`
	--sizeLogoHeight: var(--sp6x);

	height: var(--sizeLogoHeight);

	svg {
		height: var(--sizeLogoHeight);
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeLogoHeight: var(--sp5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--sizeLogoHeight: var(--sp4x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--sizeLogoHeight: var(--sp3-5x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--sizeLogoHeight: var(--sp3-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--sizeLogoHeight: var(--sp3x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--sizeLogoHeight: var(--sp3x);
	}
`;

export default LogoStyle;
